import { LinearProgress, useIsMobileOrTablet } from '@epilot/concorde-elements'
import { getPercent } from '@epilot/concorde-elements/src/components/LinearProgress/utils'
import classNames from 'classnames'
import { memo } from 'react'
import { useTranslation } from 'react-i18next'

import { useAppStoreSelector } from '../../../../hooks/useAppStoreSelector'
import { selectNumberOfSteps } from '../../../../store/selectors/config'
import { selectNumberOfRemainingSteps } from '../../../../store/selectors/runtime'

import { DesktopStepper, MobileStepper } from './components'
import classes from './JourneyStepper.module.scss'
import type { JourneyStepperProps } from './types'

export const JourneyStepper = memo(
  ({ onChangeStepIndex, isProgressBar }: JourneyStepperProps) => {
    const { t } = useTranslation()
    const isMobileOrTablet = useIsMobileOrTablet()
    const totalSteps = useAppStoreSelector(selectNumberOfSteps)
    const remainingSteps = useAppStoreSelector(selectNumberOfRemainingSteps)

    // if not linear or if linear + maxSteps higher than limit -> Progressbar
    if (isProgressBar) {
      const completeSteps = totalSteps - remainingSteps
      const percentage = Math.round(getPercent(completeSteps, totalSteps))

      return (
        <LinearProgress
          aria-label={t('stepper.label_progress', { percentage })}
          className={classes.progressBar}
          height={8}
          max={totalSteps}
          value={completeSteps}
        />
      )
    }

    if (isMobileOrTablet) {
      return <MobileStepper onStepClick={onChangeStepIndex} />
    }

    return (
      <div className={classNames(classes.wrapper, classes.concordeLayout)}>
        <DesktopStepper onStepClick={onChangeStepIndex} />
      </div>
    )
  }
)

JourneyStepper.displayName = 'JourneyStepper'
